import module from 'kendu/legacy/module'
import { forEach } from 'lodash'

export class AppHttpCache {
  constructor ($cacheFactory) {
    this.$cacheFactory = $cacheFactory
    this.caches = {}
  }

  get (name) {
    if (!this.caches[name]) {
      this.caches[name] = this.$cacheFactory(name)
    }

    return this.caches[name]
  }

  clear (name) {
    if (this.caches[name]) {
      this.caches[name].removeAll()
    }
  }

  destroy () {
    forEach(this.caches, function (cache) {
      cache.removeAll()
    })
  }
}

module.service('AppHttpCache', AppHttpCache)



// WEBPACK FOOTER //
// ./src/deprecated/services/AppHttpCache.js